import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from 'src/app/shared/services/alert.service';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html'
})
export class AlertComponent implements OnInit {
  visible = false;
  timeoutId;
  alert$;

  constructor(private alertService: AlertService) { }

  ngOnInit() {
    this.alert$ = this.alertService.alert.pipe(
      tap(alert => {
        if (alert.message) {
          this.visible = true;
          if (!this.timeoutId) {

            this.timeoutId = setTimeout(_ => this.visible = false, 3000);
          } else {
            clearTimeout(this.timeoutId);
            this.timeoutId = undefined;
          }
        }
      }));
  }

  isChecked(event) {
    this.visible = event.target.checked;
  }
}
